export default {
  modelName: "factory_api_sync_module",
  label: "同步API紀錄",
  fields: {
    module: {
      type: "text",
      label: "模組名稱",
      readonly: true,
    },
    module_id: {
      type: "text",
      label: "模組ID",
      readonly: true,
    },
    module_uuid: {
      type: "text",
      label: "模組UUID",
      readonly: true,
      getText: (value) => {
        return value ? value : '無';
      }
    },
    date: {
      type: "datetime",
      label: "同步時間",
      readonly: true,
    },
    status: {
      type: "text",
      label: "同步狀態",
      readonly: true,
    },
    message: {
      type: "text",
      label: "訊息",
      readonly: true,
      getText: (value) => {
        return value ? value : "無";
      },
    }
  },
};